<template>
  <div class="hm-transfer">
    <div class="flex item-center">
      <!-- 左边 -->
      <div class="table">
        <div class="table-out-header flex flex-between">
          <div class="tranfer-checkbox-wrapper">
            <el-checkbox
              :indeterminate="leftIsIndeterminate"
              :disabled="leftData.length <= 0"
              v-model="leftCheckAll"
              @change="handleLeftCheckAllChange"
            >
              <span class="check-all">全选</span>
            </el-checkbox>
          </div>
          <div class="transfer-title flex-2 text-center">{{ leftName }}</div>
          <div class="transfer-title text-right">共{{ leftData.length }}条</div>
        </div>
        <div class="table-header flex flex-between">
          <div class="flex-1 text-center" v-for="(v, i) in leftProps" :key="i">
            {{ v.name }}
          </div>
        </div>
        <div class="table-body">
          <RecycleScroller
            class="scroller"
            :items="leftData"
            :item-size="40"
            key-field="id"
             v-slot="{ item,index }"
          >
            <!-- <template #item="{ item }"> -->
              <el-checkbox-group
                :disabled="disabled"
                v-model="leftChecked"
                @change="handleLeftCheckedChange"
              >
                <div
                  class="check-wrapper flex item-center"
                  :title="item.attrValue"
                  :style="index % 2 != 0 ? 'background: #f7f7f7;' : ''"
                >
                  <div class="flex-3">
                    <el-checkbox :label="item" class="flex item-center">
                      <span
                        class="flex-1"
                        style="padding-left: 10px;"
                        v-for="(prop, index) in leftProps"
                        :key="index"
                        >{{ item[prop.value] }}</span
                      >
                    </el-checkbox>
                  </div>
                </div>
              </el-checkbox-group>
            <!-- </template> -->
          </RecycleScroller>
        </div>
      </div>
      <!-- 按钮 -->
      <div class="flex flex-column control text-center">
        <div class="mb20">操作</div>
        <!-- <el-switch
          size="mini"
          class="transfer-switch"
          v-if="showUseable"
          v-model="whitelistState"
          :disabled="disabled"
          active-text="黑名单"
          inactive-text="白名单"
          active-value="black"
          inactive-value="white"
        ></el-switch> -->
         <el-switch
          size="mini"
          class="transfer-switch"
          v-if="showUseable"
          v-model="whitelistState"
          :disabled="disabled"
          active-text="黑名单"
          inactive-text="白名单"
          active-value="black"
          inactive-value="white"
        ></el-switch>
        <el-button
          size="small"
          class="hmicon icon-youshuangjiantou1"
          @click="allToRight"
          :disabled="leftData.length <= 0 || disabled"
        ></el-button>
        <el-button
          size="small"
          class="hmicon icon-youjiantou"
          @click="toRight"
          :disabled="
            leftData.length <= 0 || leftChecked.length <= 0 || disabled
          "
        ></el-button>
        <el-button
          size="small"
          class="hmicon icon-zuoshuangjiantou1"
          @click="allToLeft"
          :disabled="rightData.length <= 0 || disabled"
        ></el-button>
        <el-button
          size="small"
          class="hmicon icon-zuojiantou"
          @click="toLeft"
          :disabled="
            rightData.length <= 0 || rightChecked.length <= 0 || disabled
          "
        ></el-button>
        <el-button
          size="small"
          class="hmicon icon-zuojiantou delete-selected"
          @click="deleteChecked"
          :disabled="
            leftChecked.length <= 0 || rightData.length <= 0 || disabled
          "
        >
          剔除
          <el-tooltip
            class="item"
            effect="dark"
            content="剔除右侧列表和左侧已勾选的相同的选项"
            placement="top-end"
          >
            <i class="hmicon icon-wenhao"></i>
          </el-tooltip>
        </el-button>
      </div>
      <!-- 右边 -->
      <div class="table">
        <div class="table-out-header flex flex-between">
          <div class="tranfer-checkbox-wrapper">
            <el-checkbox
              :indeterminate="rightIsIndeterminate"
              :disabled="rightData.length <= 0 || disabled"
              v-model="rightCheckAll"
              @change="handleRightCheckAllChange"
            >
              <span class="check-all">全选</span>
            </el-checkbox>
          </div>
          <div class="transfer-title flex-2 text-center">{{ rightName }}</div>
          <div class="transfer-title text-right">共{{ rightData.length }}条</div>
        </div>
        <div class="table-header flex flex-between">
          <div class="flex-1 text-center" v-for="(v, i) in rightProps" :key="i">
            {{ v.name }}
          </div>
        </div>
        <div class="table-body">
          <RecycleScroller
            class="scroller"
            :items="rightData"
            :item-size="40"
            key-field="id"
             v-slot="{ item,index }"
             style="overflow-x: auto !important;"
          >
            <!-- <template #item="{ item }"> -->
              <el-checkbox-group
                v-model="rightChecked"
                @change="handleRightCheckedChange"
                :disabled="disabled"
              >
                <draggable :list="rightData">
                  <div
                    class="check-wrapper item-center"
                    :key="item.id"
                    draggable="true"
                    @dragstart="dragStart($event, item)"
                    @dragover.prevent
                    @drop="drop($event, index)"
                    :style="index % 2 != 0 ? 'background: #f7f7f7;' : ''"
                  >
                    <div class="flex">
                      <el-checkbox :label="item" class="flex item-center">
                        <span
                          class="flex-1 move"
                          style="padding-left: 10px;"
                          v-for="(prop, index) in rightProps"
                          :key="index"
                          >{{ item[prop.value] }}</span
                        >
                      </el-checkbox>
                    </div>
                  </div>
                </draggable>
              </el-checkbox-group>
            <!-- </template> -->
          </RecycleScroller>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="errValidGoods" width="30%" title="提示">
      <div>
        <div>
          您有
          <span class="error">{{ errInputResult.length }}</span
          >条数据有误未导入
        </div>
        <el-table :data="errInputResult" border class="small-table">
          <el-table-column prop="goodsSn" label="错误货号">
            <template slot-scope="scope">
              {{ scope.row }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { arrayUnique2 } from "@/utils/utils";
import draggable from "vuedraggable";
import { RecycleScroller } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

export default {
  components: { draggable, RecycleScroller },
  props: {
    showUseable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isVouchers: {
      type: Boolean,
      default: false
    },
    showAttribute: {
      type: Boolean,
      default: false
    },
    onlySelectGoods: {
      type: Boolean,
      default: false
    },
    showMustDelivery: {
      type: Boolean,
      default: false
    },
    leftProps: {
      type: Array,
      default: () => []
    },
    rightProps: {
      type: Array,
      default: () => []
    },
    compareKey: {
      type: String,
      default: ""
    },
    leftName: { type: String },
    rightName: { type: String },
    leftOption: { type: Array },
    rightOption: { type: Array },
    queryIsUsed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
       draggedItem: null,
      errInputResult: [],
      errValidGoods: false,
      whitelistState: "white",
      isCheckedAttribute: false,
      isMustDelivery: false,
      catId: "",
      brandId: "",
      goodsName: "",
      categoryList: [],
      brandList: [],
      leftCheckAll: false,
      leftChecked: [],
      leftData: [],
      leftIsIndeterminate: false,
      rightCheckAll: false,
      rightChecked: [],
      rightData: [],
      rightIsIndeterminate: false,
      isEnableSession: false,
      sendWayType: "",
      isChecked: false
    };
  },
  computed: mapGetters([
    "offlineGoodsListResult",
    "offlineBrandList",
    "crossQueryResult"
  ]),

  watch: {
    showUseable(val) {
      if (val) {
        this.whitelistState = "white";
      }
    },
    crossQueryResult(val) {
      if (val.length) {
        this.leftData = val;
        this.leftData.forEach(v => {
          v.goodsPackageNum = 1;
            v.id = v.id || Math.random().toString(36).substring(2, 6);
          if (v.goodsName) {
            v.goodsInfo = v.goodsName;
          }
        });
      } else {
        this.leftData = [];
      }
    },
    offlineGoodsListResult(val) {
      if (val.length) {
        this.leftData = val;
        this.leftData.forEach(v => {
          v.goodsPackageNum = 1;
          v.id = v.id || Math.random().toString(36).substring(2, 6);
          if (v.goodsName) {
            v.goodsInfo = v.goodsName;
          }
        });
      } else {
        this.leftData = [];
      }
    },
    leftOption: {
      handler(newVal) {
        if(newVal.length) {
           this.leftData = newVal;
           this.leftData.forEach(v => {
            v.id = v.id || Math.random().toString(36).substring(2, 6);
          });
        }else {
        this.leftData = [];
      }
        console.log('---leftData---', newVal, this.leftData);
       
      },
      immediate: true,
      deep: true
    },
    rightOption: {
      handler(newVal) {
        if(newVal.length) {
           this.rightData = newVal;
           this.rightData.forEach(v => {
            v.id = v.id || Math.random().toString(36).substring(2, 6);
        });
        }else {
        this.rightData = [];
      }
       
         console.log(this.rightData,999999999)
      },
     
      // immediate: true,
      // deep: true
    },
    // leftProps:{
    //    handler(newVal) {
    //     if(newVal.length) {
    //       this.leftProps = newVal;
    //       this.leftProps.forEach(v => {
    //       v.id = v.id || Math.random().toString(36).substr(2, 6);
    //     });
    //     }
       
    //   },
    //   immediate: true,
    //   deep: true
    // },
    //  rightProps:{
    //    handler(newVal) {
    //     if(newVal.length) {
    //      this.rightProps = newVal;
    //     this.rightProps.forEach((v,i) => {
    //      v.id = v.id || Math.random().toString(36).substr(2, 6);
    //     });
    //     }
       
    //   },
    //   immediate: true,
    //   deep: true
    // },
    //   rightData:{
    //    handler(newVal) {
    //     if(newVal.length) {
    //      this.rightData = newVal;
    //     this.rightData.forEach((v,i) => {
    //      v.id = v.id || Math.random().toString(36).substr(2, 6);
    //     });
    //     }else {
    //     this.rightData = [];
    //   }
       
    //   },
    //   immediate: true,
    //   deep: true
    // },
    
    rightChecked() {
      this.$emit("getTransferResult", this.rightData);
    }
  },
  mounted() {},
  methods: {
      dragStart(event, item) {
      this.draggedItem = item;
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('item', JSON.stringify(item));
    },
    drop(event, index) {
      const draggedItem = this.draggedItem;
      const targetIndex = index;
      const draggedIndex = this.rightData.indexOf(draggedItem);

      if (draggedIndex !== targetIndex) {
        this.rightData.splice(draggedIndex, 1);
        this.rightData.splice(targetIndex, 0, draggedItem);
      }

      this.draggedItem = null;
      this.$emit("getTransferResult", this.rightData);
    },
    handleLeftCheckAllChange(val) {
      // 选择左边的全选
      this.leftChecked = val ? this.leftData : [];
      this.leftIsIndeterminate = false;
    },
    handleLeftCheckedChange(value) {
      // 选择左边的checkbox
      let checkedCount = value.length;
      this.leftCheckAll = checkedCount === this.leftData.length;
      this.leftIsIndeterminate =
        checkedCount > 0 && checkedCount < this.leftData.length;
    },
    handleRightCheckAllChange(val) {
      // 选择右边的全选
      this.rightChecked = val ? this.rightData : [];
      this.rightIsIndeterminate = false;
      this.$emit("getTransferResult", this.rightData);
    },
    handleRightCheckedChange(value) {
      // 选择右边的checkbox
      let checkedCount = value.length;
      this.rightCheckAll = checkedCount === this.rightData.length;
      this.rightIsIndeterminate =
        checkedCount > 0 && checkedCount < this.rightData.length;
      this.$emit("getTransferResult", this.rightData);
    },
    allToRight() {
      // 移动所有到右边
      const result = this.checkCommon(this.leftData, this.rightData);
      if (!result) {
        if (this.showUseable) {
          this.leftData.forEach(v => {
            v.whitelistState = this.whitelistState;
          });
        }
        if (this.queryIsUsed) {
          this.rightData = this.leftData;
          this.rightData.forEach(v => {
            v.activityName = v.existActivity
              ? v.existActivity.map(item => item.promotionName)
              : [];
            v.activityStr = v.activityName.join(",");
            if (this.isMustDelivery) {
              v.isMustDelivery = this.isMustDelivery;
            }
          });

          this.leftData = [];
          this.leftChecked = [];
          this.handleRightCheckAllChange(true);
          this.leftCheckAll = false;
          this.rightCheckAll = true;
          //   this.$store
          //     .dispatch("queryGoodsIsUsed", {
          //       leftData: this.leftData
          //     })
          //     .then(res => {
          //       if (this.leftData.length > 0) {
          //         this.rightData = this.rightData.concat(res.result);
          //         this.rightData.forEach(v => {
          //           v.activityName = v.existActivity
          //             ? v.existActivity.map(item => item.promotionName)
          //             : [];
          //           v.activityStr = v.activityName.join(",");
          //           if (this.isMustDelivery) {
          //             v.isMustDelivery = this.isMustDelivery;
          //           }
          //         });
          //         this.leftData = [];
          //         this.leftChecked = [];
          //       }
          //       this.handleRightCheckAllChange(true);
          //       this.leftCheckAll = false;
          //       this.rightCheckAll = true;
          //     });
        } else {
          if (this.leftData.length > 0) {
            this.rightData = this.rightData.concat(this.leftData);
            this.rightData.forEach(v => {
              if (this.isMustDelivery) {
                v.isMustDelivery = this.isMustDelivery;
              }
            });
            this.leftData = [];
            this.leftChecked = [];
          }
          this.handleRightCheckAllChange(true);
          this.leftCheckAll = false;
          this.rightCheckAll = true;
        }
      }
      this.$emit("getTransferResult", this.rightData);
    },
    toRight() {
      // 移动选中到右边
      console.log(JSON.stringify(this.leftChecked)+'左边')
      console.log(JSON.stringify(this.rightData)+'右边')
      const result = this.checkCommon(this.leftChecked, this.rightData);

      if (!result) {
        if (this.showUseable) {
          this.leftData.forEach(v => {
            v.whitelistState = this.whitelistState;
          });
        }

        if (this.queryIsUsed) {
          // this.rightData = this.leftData;
          this.rightData = this.rightData.concat(this.leftChecked);
          this.rightData.forEach(v => {
            v.activityName = v.existActivity
              ? v.existActivity.map(item => item.promotionName)
              : [];
            v.activityStr = v.activityName.join(",");
            if (this.isMustDelivery) {
              v.isMustDelivery = this.isMustDelivery;
            }
          });

          // this.leftData = [];
          // this.leftChecked = [];
          // this.handleRightCheckAllChange(true);
          // this.leftCheckAll = false;
          // this.rightCheckAll = true;
          //   this.$store
          //     .dispatch("queryGoodsIsUsed", {
          //       leftData: this.leftChecked
          //     })
          //     .then(res => {
          //       this.rightData = this.rightData.concat(res.result);
          //       this.rightData.forEach(v => {
          //         v.activityName = v.existActivity
          //           ? v.existActivity.map(item => item.promotionName)
          //           : [];
          //         v.activityStr = v.activityName.join(",");
          //         if (this.isMustDelivery) {
          //           v.isMustDelivery = this.isMustDelivery;
          //         }
          //       });
          //       this.leftChecked = [];
          //       this.leftIsIndeterminate = false;
          //       this.leftCheckAll = false;
          //       this.handleRightCheckAllChange(true);
          //       this.rightCheckAll = true;
          //     });
        } else {
          this.rightData = this.rightData.concat(this.leftChecked);
          this.rightData.forEach(v => {
            if (this.isMustDelivery) {
              v.isMustDelivery = this.isMustDelivery;
            }
          });
        }
        if (this.leftChecked.length === this.leftData.length) {
          this.leftData = [];
        } else if (this.leftChecked.length === 1) {
          this.leftData.forEach((v, i) => {
            if (v[this.compareKey] === this.leftChecked[0][this.compareKey]) {
              this.leftData.splice(i, 1);
            }
          });
        } else {
          this.leftChecked.forEach(v => {
            this.leftData.forEach((item, index) => {
              if (v[this.compareKey] === item[this.compareKey]) {
                this.leftData.splice(index, 1);
              }
            });
          });
        }
        this.leftChecked = [];
        this.leftIsIndeterminate = false;
        this.leftCheckAll = false;
        this.handleRightCheckAllChange(true);
        this.rightCheckAll = true;
      }
      this.$emit("getTransferResult", this.rightData);
    },
    allToLeft() {
      // 移动所有到左边
      // const result = this.checkCommon(this.rightData, this.leftData);
      // if (!result) {
      this.rightCheckAll = false;
      this.rightIsIndeterminate = false;
      if (this.rightData.length > 0) {
        this.leftData = this.leftData.concat(this.rightData);
        this.leftData = arrayUnique2(this.leftData, this.compareKey);
        this.rightData = [];
        this.rightChecked = [];
      }
      // }
      // const result = this.checkCommon(this.rightChecked, this.leftData);
      // if (!result) {
      this.leftData = this.leftData.concat(this.rightChecked);
      this.leftData = arrayUnique2(this.leftData, this.compareKey);
      if (this.rightChecked.length === this.rightData.length) {
        this.rightData = [];
        this.rightChecked = [];
        this.rightCheckAll = false;
      } else if (this.rightChecked.length === 1) {
        this.rightData.forEach((v, i) => {
          if (v[this.compareKey] === this.rightChecked[0][this.compareKey]) {
            this.rightData.splice(i, 1);
          }
        });
        this.rightChecked = [];
      } else {
        this.rightChecked.forEach(v => {
          this.rightData.forEach((item, index) => {
            if (v[this.compareKey] === item[this.compareKey]) {
              this.rightData.splice(index, 1);
            }
          });
        });
      }
      this.rightChecked = [];
      this.rightIsIndeterminate = false;
      // }
      this.$emit("getTransferResult", this.rightData);
    },
    toLeft() {
      // 移动选中到左边
      // const result = this.checkCommon(this.rightChecked, this.leftData);
      // if (!result) {
      this.leftData = this.leftData.concat(this.rightChecked);
      this.leftData = arrayUnique2(this.leftData, this.compareKey);
      if (this.rightChecked.length === this.rightData.length) {
        this.rightData = [];
        this.rightChecked = [];
        this.rightCheckAll = false;
      } else if (this.rightChecked.length === 1) {
        this.rightData.forEach((v, i) => {
          if (v[this.compareKey] === this.rightChecked[0][this.compareKey]) {
            this.rightData.splice(i, 1);
          }
        });
        this.rightChecked = [];
      } else {
        this.rightChecked.forEach(v => {
          this.rightData.forEach((item, index) => {
            if (v[this.compareKey] === item[this.compareKey]) {
              this.rightData.splice(index, 1);
            }
          });
        });
      }
      this.rightChecked = [];
      this.rightIsIndeterminate = false;
      // }
      this.$emit("getTransferResult", this.rightData);
    },
    deleteChecked() {
      // 剔除右边和左边相同的
      if (this.leftChecked.length > 0) {
        this.leftChecked.forEach(v => {
          this.rightData.forEach((item, index) => {
            if (v.name === item.name) {
              this.rightData.splice(index, 1);
            }
          });
        });
        this.rightCheckAll = false;
      }
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
   checkCommon(checkedData, data) {
    // 如果任一数组为空，直接返回 false
    if (!Array.isArray(checkedData) || !Array.isArray(data) || checkedData.length === 0 || data.length === 0) {
        return false;
    }

    // 确保 compareKey 存在且有效
    if (!this.compareKey) {
        console.error("compareKey 未定义");
        return false;
    }

    // 使用 Set 提升查找效率
    const dataMap = new Set(data.map(item => item[this.compareKey]));

    let hasDuplicate = false;

    // 遍历 checkedData 并检查重复项
    checkedData.forEach(v => {
        if (v.hasOwnProperty(this.compareKey) && dataMap.has(v[this.compareKey])) {
            if (!hasDuplicate) {
                this.$message({
                    message: "请不要移动重复项",
                    type: "warning"
                });
                hasDuplicate = true;
            }
        }
    });

    return hasDuplicate;
}
  }
};
</script>

<style lang="scss" scoped>
.scroller {
  height: 510px;
  width: 100%; /* 确保宽度适应父容器 */
  overflow-x: auto; /* 确保水平滚动条显示 */
   &::-webkit-scrollbar {
        width: 0; /* Chrome, Safari, Edge */
      }
  &:hover {
        &::-webkit-scrollbar {
        width: 6px; /* 滚动条宽度 */
        }
        &::-webkit-scrollbar-track {
          background: #f1f1f1; /* 滚动条轨道背景色 */
        }
        &::-webkit-scrollbar-thumb {
          background: #d7d8da; /* 滚动条滑块背景色 */
          border-radius: 4px; /* 滑块圆角 */
        }
        &::-webkit-scrollbar-thumb:hover {
          background: #c7c9cc; /* 滑块悬停时的背景色 */
        }
      }
  
}

.hm-transfer {
  border: none;
  // width: 100%; /* 确保宽度适应父容器 */
  padding:0 !important;
  .table {
    margin: 20px 0;
    border: 1px solid #eaeaea;
    width: 100%; /* 确保宽度适应父容器 */
    overflow-x: auto; /* 确保水平滚动条显示 */
    &::-webkit-scrollbar {
      width: 4px; /* 滚动条宽度 */
    }
    &::-webkit-scrollbar-track {
      background: #f1f1f1; /* 滚动条轨道背景色 */
    }
    &::-webkit-scrollbar-thumb {
      background: #888; /* 滚动条滑块背景色 */
      border-radius: 2px; /* 滑块圆角 */
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #555; /* 滑块悬停时的背景色 */
    }
    .table-out-header,
    .no-message {
      padding: 12px;
    }
    .text-right {
      position: absolute;
      right: 10px;
    }
    .table-header {
      padding: 12px;
      background: #f7f7f7;
      font-size: 12px;
      display: flex; /* 使用 flex 布局 */
      .num {
        margin-left: 26px;
      }
      .name {
        margin-left: -26px;
      }
    }
    .table-body {
      font-size: 12px;
      overflow-x: auto; /* 确保水平滚动条显示 */
      min-width: 100%; /* 确保内容宽度超过容器宽度时触发滚动条 */
      display: flex; /* 使用 flex 布局 */
      flex-direction: column; /* 确保子元素垂直排列 */
      &::-webkit-scrollbar {
        width: 4px; /* 滚动条宽度 */
      }
      &::-webkit-scrollbar-track {
        background: #f1f1f1; /* 滚动条轨道背景色 */
      }
      &::-webkit-scrollbar-thumb {
        background: #888; /* 滚动条滑块背景色 */
        border-radius: 2px; /* 滑块圆角 */
      }
      &::-webkit-scrollbar-thumb:hover {
        background: #555; /* 滑块悬停时的背景色 */
      }
      .check-wrapper {
        padding-left: 12px;
        display: flex; /* 使用 flex 布局 */
        flex-direction: row; /* 确保子元素水平排列 */
        .flex-3 {
          flex: 3; /* 确保子元素宽度自适应 */
        }
      }
      .el-checkbox {
        width: 100%;
      }
      .el-checkbox__label {
        width: calc(100% - 24px);
        display: flex;
      }
    }
  }
  .el-checkbox {
    margin-right: 0;
  }
}

.open-file {
  position: relative;
  overflow: hidden;
}
.open-file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}
.tree-wrapper {
  width: 500px;
}
.transfer {
  border: 1px solid #e7e8ec;
  height: 485px;
  width: 100%; /* 确保宽度适应父容器 */
  border-radius: 5px;
}
.transfer-header {
  padding: 1rem;
  background: #ecf2ff;
  border-radius: 5px 5px 0 0;
}
.table-out-header {
  position: relative;
}
.transfer-body {
  padding: 1rem;
  border-radius: 0 0 5px 5px;
  height: 403px;
  overflow-y: scroll;
}
.control {
  width: 130px;
  margin: 0 2rem;
  .el-button {
    margin: 0.5rem;
  }
}
.coupon-type,
.coupon-count,
.check-wrapper {
  padding: 12px;
  font-size: 14px;
}
.delete-selected {
  position: relative;
  .hmicon icon-wenhao {
    position: absolute;
    right: -7px;
    top: -7px;
    font-size: 1.2rem;
    color: #4680ff;
  }
}
.checkbox-group-wrapper {
  border-left: 1px solid #e7e8ec;
  border-right: 1px solid #e7e8ec;
  padding: 0 0.5rem;
}

input[type="number"] {
  width: 2rem;
  border: none;
  outline: none;
  text-align: center;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
.leftName,
.rightName {
  margin-left: -52px;
}

.error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
}

.minus,
.plus {
  transition: background 0.2s linear;
  cursor: pointer;
}
.disabled {
  color: rgb(220, 223, 230);
  cursor: not-allowed;
}

.divide {
  .divide-header {
    display: flex;
    display: -webkit-flex;
    padding-left: 24px;
    border-bottom: 1px solid #e7e8ec;
    padding-bottom: 1rem;
    color: #999;
    width: 100%;
    box-sizing: border-box;
    height: 30px;
    span {
      flex: 1;
      -webkit-flex: 1;
      padding-right: 0.5rem;
    }
  }
  .el-checkbox__label {
    span {
      flex: 1;
      -webkit-flex: 1;
      padding-right: 0.5rem;
    }
  }

  .check-wrapper {
    margin: 1rem 0;
  }
}

.transfer-body {
  .divide-header {
    display: flex;
    display: -webkit-flex;
    padding-left: 24px;
    border-bottom: 1px solid #e7e8ec;
    padding-bottom: 1rem;
    color: #999;
    width: 100%;
    box-sizing: border-box;
    height: 30px;
    .count {
      width: 56px;
    }
    .devide-type,
    .coupon-type,
    .coupon-target {
      display: flex;
      flex: 1;
      -webkit-flex: 1;
    }
    .coupon-name {
      display: flex;
      flex: 2;
      -webkit-flex: 2;
    }
    .coupon-name.flex1 {
      flex: 1;
      -webkit-flex: 1;
    }
    .devide-type {
      span {
        padding-right: 0.5rem;
      }
    }
  }
  .check-wrapper {
    margin: 1rem 0;
  }
  .devide-body {
    .devide-type,
    .coupon-type,
    .coupon-target {
      display: flex;
      flex: 1;
      -webkit-flex: 1;
    }
    .coupon-name {
      display: flex;
      flex: 2;
      -webkit-flex: 2;
    }
    .coupon-type {
      display: flex;
      align-items: center;
    }
  }
}

.attrId {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 195px;
}

.tranfer-checkbox-wrapper {
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  .check-all {
    margin-left: 10px;
  }
}
</style>